// Center the emoji picker popup (only for non-above-message pickers and non-text-input pickers)
(function() {
  // We'll use MutationObserver to wait for the emoji picker to appear
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach((node) => {
          // Skip if it's inside an emoji-picker-above-message container
          if (node.closest && node.closest('.emoji-picker-above-message')) {
            return;
          }
          
          // Skip if it's the text input emoji picker (with slide-up animation)
          if (node.classList && node.classList.contains('emoji-picker-popup-content')) {
            return;
          }
          
          // Check for popup content div
          if (node.classList && node.classList.contains('popup-content')) {
            // Skip if parent is emoji-picker-above-message
            if (node.closest('.emoji-picker-above-message')) return;
            // Skip if it's the text input emoji picker
            if (node.classList.contains('emoji-picker-popup-content')) return;
            centerEmojiPicker(node);
          }
          
          // Also check for any emoji picker that might be added dynamically
          if (node.tagName === 'EM-EMOJI-PICKER') {
            if (node.closest('.emoji-picker-above-message')) return;
            const popup = node.closest('.popup-content');
            // Skip if it's the text input emoji picker
            if (popup && popup.classList.contains('emoji-picker-popup-content')) return;
            if (popup) centerEmojiPicker(popup);
          }
        });
      }
    });
  });
  
  // Start observing the document
  observer.observe(document.body, { 
    childList: true,
    subtree: true
  });
  
  function centerEmojiPicker(popupElement) {
    // Skip if inside emoji-picker-above-message
    if (popupElement.closest('.emoji-picker-above-message')) return;
    // Skip if it's the text input emoji picker
    if (popupElement.classList.contains('emoji-picker-popup-content')) return;
    
    // Reset inline styles first
    popupElement.style.cssText = '';
    
    // Apply only the essential styles
    popupElement.style.position = 'fixed';
    popupElement.style.top = '50%';
    popupElement.style.left = '50%';
    popupElement.style.transform = 'translate(-50%, -50%)';
    popupElement.style.zIndex = '9999';
    popupElement.style.width = 'auto';
    popupElement.style.maxWidth = '90vw';
    
    // Find and style the emoji picker inside
    const emojiPicker = popupElement.querySelector('em-emoji-picker');
    if (emojiPicker) {
      emojiPicker.style.cssText = '';
      emojiPicker.style.maxHeight = '480px';
      emojiPicker.style.overflowY = 'auto';
      emojiPicker.style.width = 'auto';
    }
  }
})(); 